import { contentQualityAttributes } from "@/lib/seo/content-quality";

/** A direct answer composed from the same facts the page renders. */
export default function AnswerSummary({ answer }: { answer: string }) {
  // Semantic roles only — the adoption ratchet rejects inline style objects,
  // `--ish-*` aliases, and arbitrary type sizes, and it is right to: they fork
  // the theme/typography scale this block has no reason to leave.
  return (
    <div
      data-testid="answer-summary"
      data-answer-summary=""
      {...contentQualityAttributes({ facet: "direct_answer" })}
      className="mt-5 rounded-lg border-l-4 border-border-interactive bg-surface-brand-subtle p-4"
    >
      <p className="text-body leading-relaxed text-text-primary">{answer}</p>
    </div>
  );
}
